import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";
import LandingPage from "src/content/pages/Landing";
import useAuth from "src/hooks/useAuth";

import SuspenseLoader from "src/components/SuspenseLoader";
import Authenticated from "src/components/Authenticated";
import PermissionGuard from "src/components/PermissionGuard";

const HomeRoute = () => {
  const auth = useAuth();
  if (!auth.isInitialized) return null;
  if (auth.isAuthenticated) {
    return <Navigate to="extended-sidebar/menu/home" replace />;
  }
  return <LandingPage />;
};

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const PlansPage = Loader(lazy(() => import("src/content/pages/Plans")));
// Página pública de Podcast, alcançada pelo menu do nav das páginas abertas.
// Lazy como a de planos: são ~680 linhas de mockup que não precisam entrar no
// bundle de quem só abre a home.
const PodcastPage = Loader(lazy(() => import("src/content/pages/Podcast")));

const Status404 = Loader(
  lazy(() => import("src/content/pages/Status/Status404"))
);
const Status500 = Loader(
  lazy(() => import("src/content/pages/Status/Status500"))
);
const StatusComingSoon = Loader(
  lazy(() => import("src/content/pages/Status/ComingSoon"))
);
const StatusMaintenance = Loader(
  lazy(() => import("src/content/pages/Status/Maintenance"))
);

// Modo de importação para tela cheia
const Chat = Loader(lazy(() => import("src/content/chat/main")));
const ContentChat = Loader(lazy(() => import("src/content/contentChat/main")));
const MediaPlayer = Loader(lazy(() => import("src/content/mediaPlayer/main")));
const EmailValidation = Loader(
  lazy(() => import("src/content/pages/Auth/EmailValidation/emailValidation"))
);
const EmailVerify = Loader(
  lazy(() => import("src/content/pages/Auth/EmailVerify/emailVerify"))
);
const SuccessLogin = Loader(
  lazy(() => import("src/content/pages/Auth/SuccessLogin/successLogin"))
);

const Mural = Loader(lazy(() => import("src/content/mural/mural")));
const TelespectadorCadastro = Loader(
  lazy(() => import("src/content/tv30/TelespectadorCadastro"))
);
const PodcastApresentacao = Loader(lazy(() => import("src/content/podcast/Apresentacao")));
const BertaTeleprompterTela = Loader(lazy(() => import("src/content/berta/TeleprompterTela")));
// const QRCode = Loader(lazy(() => import("src/content/chat/components/qrCode")));

const baseRoutes = [
  {
    path: "/",
    element: <HomeRoute />,
  },
  {
    path: "planos",
    element: <PlansPage />,
  },
  // Pública, antes do login — não confundir com "podcast-apresentacao", que é
  // a tela de apresentação do produto e já existia.
  {
    path: "podcast",
    element: <PodcastPage />,
  },
  // Cadastro do telespectador da TV 3.0 — aberto pelo celular ao ler o QR
  // Code da TV, sem login (o código do pareamento é o que autoriza).
  {
    path: "telespectador/:codigo",
    element: <TelespectadorCadastro />,
  },
  {
    path: "overview",
    element: <Navigate to="/" replace />,
  },
  {
    path: "*",
    element: <Status404 />,
  },
  {
    path: "status",
    children: [
      {
        path: "500",
        element: <Status500 />,
      },
      {
        path: "maintenance",
        element: <StatusMaintenance />,
      },
      {
        path: "coming-soon",
        element: <StatusComingSoon />,
      },
    ],
  },
  {
    path: "Mural",
    element: <Authenticated><Mural /></Authenticated>,
  },
  {
    path: "mural",
    element: <Authenticated><Mural /></Authenticated>,
  },
  {
    path: "mural/settings/:tab",
    element: <Authenticated><Mural /></Authenticated>,
  },
  {
    path: "mural/:screen",
    element: <Authenticated><Mural /></Authenticated>,
  },
  {
    path: "mural/:screen/:subIndex",
    element: <Authenticated><Mural /></Authenticated>,
  },
  {
    path: "podcast-apresentacao",
    element: <PodcastApresentacao />,
  },
  // Berta — tela pública do teleprompter do estúdio (sem login; o token do
  // link autoriza e só mostra conteúdo aprovado).
  {
    path: "berta-tp/:token",
    element: <BertaTeleprompterTela />,
  },

  {
    path: "chat",
    element: <Authenticated><PermissionGuard permissionKey="whatsapp"><Chat /></PermissionGuard></Authenticated>,
  },
  {
    path: "contentChat",
    element: <Authenticated><PermissionGuard permissionKey="participacoes"><ContentChat /></PermissionGuard></Authenticated>,
  },
  {
    path: "mediaPlayer",
    element: <Authenticated><MediaPlayer /></Authenticated>,
  },
  {
    path: "emailValidation/:email",
    element: <EmailValidation />,
  },
  {
    path: "verifyemail/*",
    element: <EmailVerify />,
  },
  {
    path: "desktop/*",
    element: <SuccessLogin />,
  },
  {
    path: "*",
    element: <Status404 />,
  },
  // {
  //   path: "qrCode",
  //   element: <QRCode />,
  // },
];

export default baseRoutes;
